// extracted by mini-css-extract-plugin
export default {"cardStyle":"CardWrapper_cardStyle__VA5S2"};